import { Box, Center } from '@chakra-ui/react'
import delay from 'lodash/delay'
import { useEffect } from 'react'

import { Alert } from '@app/components/ui/alert'

const IntegrationSuccess = () => {
  useEffect(() => {
    delay(() => {
      window.close()
    }, 2500)
  })

  return (
    <Box w="full" h="100%">
      <Center h="100%">
        <Box>
          <Alert
            title="Integration connected!"
            alignItems="center"
            justifyContent="center"
            flexDir="column"
            h="200px"
            textAlign="center"
            border="1px"
            borderColor="bg.muted"
            status="success"
            variant="subtle"
          >
            Your integration has been connected, this window will close shortly.
          </Alert>
        </Box>
      </Center>
    </Box>
  )
}

export default IntegrationSuccess
